import React, { useState } from 'react'
import { appHistory } from '@core/Utils/routing/history'
import { InAppMarketingModal } from '@mobi/component-library/Areas/InAppMarketing/InAppMarketingModal'
import { useActiveMarketingNotification } from './useActiveMarketingNotification'
import { isMobiUrl } from '@core/Utils/url/url'

export const InAppMarketing = () => {
  const [isModalDismissed, setIsModalDismissed] = useState(false)
  const { activeNotification, dismissNotification, recordNotificationInteraction } =
    useActiveMarketingNotification()

  if (!activeNotification) return

  return (
    <InAppMarketingModal
      isOpen={!isModalDismissed}
      onCancel={() => {
        setIsModalDismissed(true)
        // delay to account for animation
        setTimeout(dismissNotification, 300)
      }}
      onButtonClicked={(link: string, buttonIndex: number) => {
        recordNotificationInteraction(buttonIndex)
        openLink(link)
      }}
      notification={{ ...activeNotification }}
    />
  )
}

function openLink(link: string) {
  // Relative link
  if (link.startsWith('/')) {
    appHistory.push(link)
    return
  }

  try {
    const formattedUrl = link.startsWith('http') ? link : `https://${link}`
    const validUrl = new URL(formattedUrl)

    isMobiUrl(validUrl.hostname)
      ? appHistory.push(validUrl.href)
      : window.open(validUrl.href, '_blank')
  } catch {
    // swallow deformed URL
  }
}
